/* eslint-disable @typescript-eslint/no-var-requires */
import { type PropsWithChildren } from 'react';
import React from 'react';

import { isMobile } from '@south-street-app/utils';

const MaintenanceModeProvider = ({ children }: PropsWithChildren) => {
  if (isMobile) {
    const { MaintenanceModeMobile } = require('./MaintenanceModeMobile');

    return <MaintenanceModeMobile>{children}</MaintenanceModeMobile>;
  }

  const { MaintenanceModeWeb } = require('./MaintenanceModeWeb');

  return <MaintenanceModeWeb>{children}</MaintenanceModeWeb>;
};

export { MaintenanceModeProvider };
